import React from 'react';
import PropTypes from 'prop-types';

/**
 * Using allergen data passed in from the info.jsx (PDP) component we render an allergen information list.
 *
 * @function
 * @param       {[type]} allergen [description]
 * @constructor
 */
function AllergenInfo({ allergen }) {
    //console.log('a', allergen);
    return (
        <ul>
            {allergen.map((item, idx) => {
                return <li key={`allergen-${idx}`}>{item}</li>;
            })}
        </ul>
    );
}

AllergenInfo.propTypes = {
    allergen: PropTypes.array
};

export { AllergenInfo };
